import { FACEBOOK_SIGN_IN, GOOGLE_SIGN_IN, SIGN_IN_USER, SIGN_OUT_USER, SIGN_UP_USER } from './constants';

export const authAction = {
  SIGN_IN_USER,
  GOOGLE_SIGN_IN,
  FACEBOOK_SIGN_IN,
  SIGN_OUT_USER,
  SIGN_UP_USER,
};
